import React from 'react';
import { X, Check, RefreshCw, Loader2, Sparkles } from 'lucide-react';

interface ProjectEnhanceModalProps {
  isOpen: boolean;
  onClose: () => void;
  content: string;
  onConfirm: (content: string) => void;
  onRegenerate: () => void;
  isRegenerating: boolean;
}

const ProjectEnhanceModal: React.FC<ProjectEnhanceModalProps> = ({
  isOpen,
  onClose,
  content,
  onConfirm,
  onRegenerate,
  isRegenerating
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b bg-gradient-to-r from-purple-50 to-pink-50">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg">
              <Sparkles size={20} className="text-white" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">AI 创意优化结果</h2>
              <p className="text-sm text-gray-500">AI 为您生成的实战项目说明</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X size={20} className="text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-6 py-4">
          <div className="bg-gray-50 rounded-lg p-4 min-h-[300px]">
            <p className="text-gray-700 whitespace-pre-wrap leading-relaxed">
              {content || '正在生成内容...'}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between px-6 py-4 border-t bg-gray-50">
          <button
            onClick={onRegenerate}
            disabled={isRegenerating}
            className="flex items-center gap-2 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isRegenerating ? (
              <>
                <Loader2 size={16} className="animate-spin" />
                <span>重新生成中...</span>
              </>
            ) : (
              <>
                <RefreshCw size={16} />
                <span>重新生成</span>
              </>
            )}
          </button>

          <div className="flex items-center gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              取消
            </button>
            <button
              onClick={() => onConfirm(content)}
              className="flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all shadow-sm hover:shadow-md"
            >
              <Check size={16} />
              <span>确定并保存</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectEnhanceModal;
